module.exports = __webpack_public_path__ + "e74734308089e6c2e052d53046bedfb3.svg";